module.exports = __webpack_public_path__ + "img/Congo.f9921f52.svg";